module.exports = __webpack_public_path__ + "img/promo-2.4856de80.png";